import { SUCCESS_HANDLER } from "../actions/types";

export default (response = null, action) => {
  if (action.type === SUCCESS_HANDLER) {
    return action.payload;
  }
  return response;
};
